document.addEventListener('DOMContentLoaded', function() {
  initializeBeforeAfterSliders();
  initializeTabs();

  function initializeBeforeAfterSliders() {
    const sliders = document.querySelectorAll('.pi-before-after');

    sliders.forEach(container => {
      const slider = container.querySelector('.pi-before-after-slider');
      if (slider) {
        slider.addEventListener('input', (e) => {
          container.style.setProperty('--position', `${e.target.value}%`);
        });
      }
    });
  }

  function initializeTabs() {
    const tabButtons = document.querySelectorAll('.before_after_tab');
    const sliders = document.querySelectorAll('.pi-before-after');
    const collectionButtons = document.querySelectorAll('.before_after_collection_button');

    tabButtons.forEach((tab, index) => {
      tab.addEventListener('click', function () {
        tabButtons.forEach(t => t.classList.remove('active'));
        this.classList.add('active');

        sliders.forEach(slider => slider.classList.add('hidden'));
        if (sliders[index]) sliders[index].classList.remove('hidden');

        const buttonText = this.getAttribute('data-button-text');
        const url = this.getAttribute('data-url');

        collectionButtons.forEach(button => {
          button.textContent = buttonText;
          button.setAttribute('href', url);
        });
      });
    });
  }
});
